import type { IcicleNode } from '@revelio/replots';

import type { TableRowsDataSet } from '../../DataProvider/types';

export type IcicleDrillStep = { levelId: string; id: string; name: string };

export type IcicleNodeMeta = {
  entityKey: string;
  total: number;
  count: number;
  isEntity: boolean;
  path: readonly IcicleDrillStep[];
  drillPath: readonly IcicleDrillStep[] | null;
};

export type IcicleData = {
  icicle: {
    nodes: IcicleNode[];
    meta: ReadonlyMap<string, IcicleNodeMeta>;
  };
  exportData: TableRowsDataSet | null;
};

const isSingleChain = (nodes: readonly IcicleNode[]): boolean => {
  const childCounts = new Map<string, number>();
  let roots = 0;
  for (const node of nodes) {
    if (node.parentId === null) {
      roots += 1;
      continue;
    }
    childCounts.set(node.parentId, (childCounts.get(node.parentId) ?? 0) + 1);
  }
  if (roots !== 1) return false;
  return [...childCounts.values()].every((count) => count === 1);
};

export const promoteLoneTopLevelNode = (nodes: IcicleNode[]): IcicleNode[] => {
  let current = nodes;
  for (;;) {
    if (isSingleChain(current)) return current;
    const topLevel = current.filter((node) => node.parentId === null);
    const lone = topLevel.length === 1 ? topLevel[0] : undefined;
    if (lone === undefined) return current;
    if (!current.some((node) => node.parentId === lone.id)) return current;
    current = current
      .filter((node) => node.id !== lone.id)
      .map((node) =>
        node.parentId === lone.id ? { ...node, parentId: null } : node
      );
  }
};
